import React, { PureComponent } from 'react';
import { Loader } from 'wix-style-react';

const wait = milli => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, milli);
  });
};
const DataFetcherContext = React.createContext('data-fetcher');

class StateLoader extends PureComponent {
  render() {
    return (
      <div style={{ backgroundColor: 'white', height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Loader size="large" />
      </div>
    );
  }
}

export function withDataFetcher(
  Component,
  { shouldFetch, loader = StateLoader, fetchData, minLoaderTime = 0, maxLoaderTime = Number.MAX_SAFE_INTEGER }
) {
  class ControllerDataFetcher extends PureComponent {
    constructor(props, context = {}) {
      super(props, context);
      let stateName = '';
      if (fetchData) {
        const { stateName: initializedStateName } = fetchData;
        stateName = initializedStateName;
      }
      const { fetch, notifyDataReady, initializedState } = context;
      const hasFetchData = !!fetch;
      const isAlreadyInitialized = initializedState[stateName];
      this.loader = loader;
      const isDataReady = !shouldFetch || !hasFetchData || isAlreadyInitialized;
      this.state = {
        isDataReady
      };

      if (!isDataReady) {
        this.fetchInitialData();
      } else if (isAlreadyInitialized) {
        notifyDataReady(stateName);
      }
    }

    async fetchInitialData() {
      const { fetch } = this.context;
      await Promise.all([Promise.race([fetch(fetchData), wait(maxLoaderTime)]), wait(minLoaderTime)]);
      this.setState(() => {
        return {
          isDataReady: true
        };
      });
    }

    render() {
      const { isDataReady } = this.state;
      let renderElement;
      if (isDataReady) {
        renderElement = React.createElement(Component, { ...this.props });
      } else {
        const RenderLoader = this.loader;
        renderElement = <RenderLoader />;
      }

      return renderElement;
    }
  }
  ControllerDataFetcher.contextType = DataFetcherContext;

  return ControllerDataFetcher;
}

export default DataFetcherContext;
